import type { BrandShadow } from '$lib/types/Theme';

type ShadowScale = 'A' | 'B' | 'C';

const SHADOW_SCALES: Record<ShadowScale, Record<BrandShadow, string>> = {
    // A — inputs (custom subtle)
    A: {
        none: 'fun-shadow-none',
        sm: 'fun-shadow-input-sm',
        md: 'fun-shadow-input',
        lg: 'fun-shadow-input-md',
        xl: 'fun-shadow-input-lg',
        '2xl': 'fun-shadow-input-xl',
    },
    // B — cards (standard Tailwind)
    B: {
        none: 'fun-shadow-none',
        sm: 'fun-shadow-sm',
        md: 'fun-shadow',
        lg: 'fun-shadow-md',
        xl: 'fun-shadow-lg',
        '2xl': 'fun-shadow-xl',
    },
    // C — frames (one step larger)
    C: {
        none: 'fun-shadow-none',
        sm: 'fun-shadow-sm',
        md: 'fun-shadow-md',
        lg: 'fun-shadow-lg',
        xl: 'fun-shadow-xl',
        '2xl': 'fun-shadow-2xl',
    },
};

const componentShadow = {
    // scale A — inputs
    textInput: 'A',
    textareaInput: 'A',
    fileInput: 'A',
    checkboxInput: 'A',
    // scale B — cards
    button: 'B',
    paymentForm: 'B',
    choiceItem: 'B',
    textAnswer: 'B',
    accordionItem: 'B',
    reviewsAvatar: 'B',
    // scale C — frames
    blockFrame: 'C',
    embed: 'C',
    sliderImage: 'C',
    videoQuestionFrame: 'C',
    webinarFrame: 'C',
    gridColumn: 'C',
} as const satisfies Record<string, ShadowScale>;

export const getShadow = (component: keyof typeof componentShadow, value: BrandShadow): string => {
    const scale = componentShadow[component];
    return SHADOW_SCALES[scale][value] ?? 'fun-shadow-none';
};
